"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerEventPreviewType = void 0;
var ProducerEventPreviewType;
(function (ProducerEventPreviewType) {
    ProducerEventPreviewType["LiveClips"] = "LiveClips";
    ProducerEventPreviewType["HybridClips"] = "HybridClips";
})(ProducerEventPreviewType = exports.ProducerEventPreviewType || (exports.ProducerEventPreviewType = {}));
//# sourceMappingURL=producer-event-preview-type.js.map